import React from 'react';

const ProfileBoldIcon = ({
  width = '16',
  height = '16',
  fill = '#007AFF',
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill={fill}
    {...props}
  >
    <g clipPath="url(#clip0_631_16290)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 8C1 6.14348 1.7375 4.36301 3.05025 3.05025C4.36301 1.7375 6.14348 1 8 1C9.85651 1 11.637 1.7375 12.9497 3.05025C14.2625 4.36301 15 6.14348 15 8C15 9.85651 14.2625 11.637 12.9497 12.9497C11.637 14.2625 9.85651 15 8 15C6.14348 15 4.36301 14.2625 3.05025 12.9497C1.7375 11.637 1 9.85651 1 8ZM10.716 10.4346C11.1878 10.6992 11.6148 11.0296 11.9872 11.4146C11.4949 11.9907 10.8835 12.4531 10.1951 12.77C9.50672 13.0869 8.7578 13.2507 8 13.25C6.404 13.25 4.976 12.5388 4.0128 11.416C4.86492 10.5347 5.98492 9.96043 7.19788 9.78289C8.41083 9.60534 9.64704 9.83451 10.716 10.4346ZM8 8.3234C8.27578 8.3234 8.54885 8.26908 8.80364 8.16355C9.05842 8.05801 9.28992 7.90333 9.48492 7.70832C9.67993 7.51332 9.83461 7.28182 9.94015 7.02704C10.0457 6.77225 10.1 6.49918 10.1 6.2234C10.1 5.94762 10.0457 5.67455 9.94015 5.41976C9.83461 5.16498 9.67993 4.93348 9.48492 4.73848C9.28992 4.54347 9.05842 4.38879 8.80364 4.28325C8.54885 4.17772 8.27578 4.1234 8 4.1234C7.44305 4.1234 6.9089 4.34465 6.51508 4.73848C6.12125 5.1323 5.9 5.66645 5.9 6.2234C5.9 6.78035 6.12125 7.3145 6.51508 7.70832C6.9089 8.10215 7.44305 8.3234 8 8.3234Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_631_16290">
        <rect width="14" height="14" fill="white" transform="translate(1 1)" />
      </clipPath>
    </defs>
  </svg>
);

export default ProfileBoldIcon;
